import { styled } from '@clickcease/cc-client-components-lib'

export const ConectionsStatusContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$6',
  width: '100%',
})

export const ConnectionStatussesContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$4',
})

export const ConnectionStatusCircle = styled('span', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  border: '1px solid transparent',
  cursor: 'pointer',
  variants: {
    disabled: {
      true: {
        background: '$lightDisabled',
        border: '1px solid $lightDisabled',
        color: '$disabled',
        cursor: 'not-allowed',
      },
    },
    status: {
      connected: {
        borderColor: '$errorLight',
        background: '$white',
        boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)',
      },
      enabled: {
        borderColor: '$successLight',
        background: '$white',
        boxShadow: '0px 0px 20px 0px rgba(0, 0, 0, 0.10)',
        cursor: 'default',
      },
    },
  },
})
